import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const ANNOUNCE = [
  "Free Delivery for orders over $200",
  "Free Delivery to all orders in Langley/Surrey",
];

const MENU = [
  { to: "/", label: "Home" },
  { to: "/order", label: "Order a cake" },
  { to: "/wedding", label: "Wedding Inquiry" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact Me" },
  { to: "/track", label: "Track my order" },
  { to: "/account", label: "My account" },
];

export const Navbar = () => {
  const { items } = useCart();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* announcement marquee */}
      <div className="w-full overflow-hidden bg-sugar-ink py-2 text-sugar-bg">
        <div className="flex w-max animate-marquee">
          {[...ANNOUNCE, ...ANNOUNCE].map((t, i) => (
            <span key={i} className="mx-6 flex items-center gap-6 whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.2em]">
              {t} <span className="text-sugar-rose">✦</span>
            </span>
          ))}
        </div>
      </div>

      <header className="sticky top-0 z-40 flex w-full items-center justify-between border-b border-sugar-border bg-sugar-bg/90 px-4 py-3 backdrop-blur-xl">
        <button data-testid="nav-menu-btn" onClick={() => setOpen((o) => !o)} aria-label="Menu" className="grid h-9 w-9 place-items-center rounded-full text-sugar-ink transition-colors hover:bg-sugar-blush">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
        <Link to="/" data-testid="nav-logo" className="flex flex-col items-center leading-none">
          <span className="font-display text-[30px] font-semibold lowercase tracking-tight text-sugar-ink">
            my sugar <span className="italic font-normal text-sugar-rose">obsession</span>
          </span>
          <span className="mt-1 text-[9px] font-bold uppercase tracking-[0.28em] text-sugar-ink2">Custom Cakes | by Sarah</span>
        </Link>
        <button
          data-testid="nav-cart-btn"
          onClick={() => navigate("/checkout")}
          className="relative grid h-9 w-9 place-items-center rounded-full text-sugar-ink transition-colors hover:bg-sugar-blush"
        >
          <ShoppingBag size={19} />
          {items.length > 0 && (
            <span data-testid="nav-cart-count" className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-sugar-wine px-1 text-[10px] font-bold text-white">
              {items.length}
            </span>
          )}
        </button>
      </header>

      {open && (
        <>
          <div className="fixed inset-0 z-30 bg-black/20" onClick={() => setOpen(false)} />
          <div data-testid="nav-menu-panel" className="absolute left-3 right-3 z-40 mt-2 overflow-hidden rounded-2xl border border-sugar-border bg-white shadow-2xl">
            {MENU.map((m) => (
              <button
                key={m.to}
                data-testid={`nav-menu-${m.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => { setOpen(false); navigate(m.to); }}
                className="block w-full border-b border-sugar-border/60 px-5 py-3.5 text-left text-sm font-semibold text-sugar-ink transition-colors last:border-0 hover:bg-sugar-blush"
              >
                {m.label}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
};
